import type React from "react";
import { ReactComponent as Svg } from "./assets/icon-search.svg";
import * as styles from "./Icon.module.scss";

type SearchProps = React.SVGProps<SVGSVGElement>;

export const Search = ({ className, ...props }: SearchProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
